/* globals document */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PersonIcon from 'material-ui/svg-icons/social/person';
import CompanyIcon from 'material-ui/svg-icons/social/location-city';
import CreditCardIcon from 'material-ui/svg-icons/action/credit-card';
import { Paper } from 'material-ui';
import scrollTo from 'scroll-to-element';

import AssocEmails from './companySettings/assocEmails';
import ManageUsers from './companySettings/manageUsers';
import EmailForwarding from './companySettings/email-forwarding';
import PersonalDetails from './mySettings/personalDetails';
import AccessLevel from './mySettings/accessLevel';
import Notifications from './notifications/container';
import BillingSettings from './billing/index';
import ContractSettings from './companySettings/contract-settings';
import RateFormat from './mySettings/rate-format-setting';

class Settings extends React.Component {
  componentDidMount() {
    const { activeRoute } = this.props;
    if (activeRoute) {
      this.scrollToAnchor(activeRoute);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { activeRoute } = this.props;
    if (activeRoute !== nextProps.activeRoute) this.scrollToAnchor(nextProps.activeRoute);
  }

  scrollToAnchor = (activeRoute) => {
    const element = document.querySelector(`#${activeRoute}`);
    if (element) scrollTo(`#${activeRoute}`, { offset: -70 });
  };

  render() {
    const { userType, billingEnabled } = this.props;
    return (
      <div style={{ marginBottom: '32px' }}>
        <Paper style={{ padding: '32px' }}>
          <div className="flex-center" style={{ fontSize: '30px', fontWeight: 450, textTransform: 'uppercase', color: 'rgba(0, 0, 0, 0.54)' }}>
            <PersonIcon color="rgba(0, 0, 0, 0.54)" style={{ width: '40px', height: '40px' }} /> My Settings
          </div>
          <div id="personalDetails" style={{ marginTop: '40px' }}><PersonalDetails /></div>
          <div id="accessLevel" style={{ marginTop: '40px' }}><AccessLevel /></div>
          <div id="notifications" style={{ marginTop: '40px' }}><Notifications /></div>
          <div id="rateFormat" style={{ marginTop: '40px' }}><RateFormat /></div>
        </Paper>
        <Paper style={{ padding: '32px', marginTop: '32px' }}>
          <div className="flex-center" style={{ fontSize: '30px', fontWeight: 450, textTransform: 'uppercase', color: 'rgba(0, 0, 0, 0.54)' }}>
            <CompanyIcon color="rgba(0, 0, 0, 0.54)" style={{ width: '40px', height: '40px' }} /> Company Settings
          </div>
          <div id="manage-users" style={{ marginTop: '40px' }}><ManageUsers /></div>
          <div id="secondary-emails" style={{ marginTop: '40px' }}><AssocEmails /></div>
          {
            (userType === 'Contractor') ?
              <div id="emailForwarding" style={{ marginTop: '40px' }}><EmailForwarding /></div>
              : null
          }
          {
            (userType === 'Contractor') ?
              <div id="contracting-settings" style={{ marginTop: '40px' }}>
                <ContractSettings />
              </div>
              : null
          }
        </Paper>
        {
          billingEnabled && (
            <Paper style={{ padding: '32px', marginTop: '32px' }}>
              <div className="flex-center" style={{ fontSize: '30px', fontWeight: 450, textTransform: 'uppercase', color: 'rgba(0, 0, 0, 0.54)' }}>
                <CreditCardIcon color="rgba(0, 0, 0, 0.54)" style={{ width: '40px', height: '40px' }} /> Billing Settings
              </div>
              <div id="billing" style={{ marginTop: '40px' }}><BillingSettings {...this.props} /></div>
            </Paper>
          )
        }
      </div>
    );
  }
}

Settings.propTypes = {
  activeRoute: PropTypes.string,
  billingEnabled: PropTypes.bool,
  onRouteChange: PropTypes.func,
  userType: PropTypes.string,
};

const select = ({ user }) => ({
  userType: user.getIn(['user', 'type']),
  billingEnabled: user.toJS().company.billingEnabled,
});

export default connect(select)(Settings);



// WEBPACK FOOTER //
// ./src/app/components/settings/settings.jsx